module.exports = __webpack_public_path__ + "static/assets/1e391038e9bc3c5bcadf50902980089d.png";